var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : new P(function (resolve) { resolve(result.value); }).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = y[op[0] & 2 ? "return" : op[0] ? "throw" : "next"]) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [0, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
import { Injectable } from '@angular/core';
import { EventName, Events } from '../utils/events';
import { API } from './api';
import { JobProvider } from './job';
import { ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';
export var ExportType;
(function (ExportType) {
    ExportType["Segmentation"] = "SEGMENTATION";
    ExportType["Detection"] = "BOUNDING_BOX";
    ExportType["Json"] = "RAW_JSON";
})(ExportType || (ExportType = {}));
export var ExportFramework;
(function (ExportFramework) {
    ExportFramework["TensorFlow"] = "TENSORFLOW";
    ExportFramework["Caffe"] = "CAFFE";
    ExportFramework["Json"] = "RAW_JSON";
})(ExportFramework || (ExportFramework = {}));
var Export = /** @class */ (function () {
    function Export() {
        this.classes = [];
        this.datasets = [];
        this.projects = [];
    }
    return Export;
}());
export { Export };
var ExportProvider = /** @class */ (function () {
    function ExportProvider(api, jobProvider, events, toastCtrl, translate) {
        this.api = api;
        this.jobProvider = jobProvider;
        this.events = events;
        this.toastCtrl = toastCtrl;
        this.translate = translate;
        this.exportModelOpen = false;
    }
    /**
     * Creates a new export
     */
    ExportProvider.prototype.exportData = function (exp) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var newExport, e_1;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.post('exports/', {
                                exportType: exp.type,
                                framework: exp.framework,
                                options: {
                                    mask: exp.mask,
                                    include_images: exp.includeImages,
                                    resize_images: exp.resizeImages,
                                    image_width: exp.imageWidth,
                                    image_height: exp.imageHeight,
                                    train_percent: exp.trainingPercent,
                                    validation_percent: exp.validationPercent,
                                    test_percent: exp.testPercent,
                                    send_email: exp.sendEmail,
                                    normalize_bounding_boxes: exp.normalizeBoundingBoxes,
                                    palette: exp.palette,
                                    use_existing_sets: exp.useExistingSets
                                },
                                classes: exp.classes.map(function (cls) {
                                    return {
                                        classIdentifier: cls.id,
                                        name: cls.name,
                                        color: cls.color,
                                        alias: cls.alias
                                    };
                                }),
                                datasets: exp.datasets.map(function (dataset) {
                                    return { datasetIdentifier: dataset.id };
                                }),
                                projects: exp.projects.map(function (project) {
                                    return { projectIdentifier: project.id };
                                })
                            })];
                    case 1:
                        newExport = _a.sent();
                        this.jobProvider.pollJob(newExport.message.exportIdentifier, function (job) { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.events.publish(EventName.ExportDone);
                                if (!this.exportModelOpen) {
                                    this.toastCtrl
                                        .create({
                                        message: job.state == 'Done'
                                            ? this.translate.instant('Your export has completed')
                                            : this.translate.instant('Your export has failed'),
                                        duration: 2000
                                    })
                                        .present();
                                }
                                return [2 /*return*/];
                            });
                        }); });
                        return [2 /*return*/, newExport.message.exportIdentifier];
                    case 2:
                        e_1 = _a.sent();
                        throw e_1;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get all exports for user
     */
    ExportProvider.prototype.getUserExports = function (limit, offset) {
        return __awaiter(this, void 0, void 0, function () {
            var _this = this;
            var params, queryString, myExports, e_2;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        params = [];
                        if (limit) {
                            params.push("limit=" + limit);
                        }
                        if (offset) {
                            params.push("offset=" + offset);
                        }
                        queryString = 'exports' + (params ? '?' + params.join('&') : '');
                        return [4 /*yield*/, this.api.get(queryString)];
                    case 1:
                        myExports = _a.sent();
                        return [2 /*return*/, {
                                exports: myExports.message.exports.map(function (exp) {
                                    return _this.getExportObject(exp);
                                }),
                                total: myExports.message.count
                            }];
                    case 2:
                        e_2 = _a.sent();
                        throw e_2;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Get details of a specific export
     */
    ExportProvider.prototype.getExport = function (exportIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var myExport, e_3;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.get("exports/" + exportIdentifier)];
                    case 1:
                        myExport = _a.sent();
                        return [2 /*return*/, this.getExportObject(myExport.message)];
                    case 2:
                        e_3 = _a.sent();
                        throw e_3;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Deletes an export
     */
    ExportProvider.prototype.deleteExport = function (exportIdentifier) {
        return __awaiter(this, void 0, void 0, function () {
            var e_4;
            return __generator(this, function (_a) {
                switch (_a.label) {
                    case 0:
                        _a.trys.push([0, 2, , 3]);
                        return [4 /*yield*/, this.api.delete("exports/" + exportIdentifier)];
                    case 1: return [2 /*return*/, _a.sent()];
                    case 2:
                        e_4 = _a.sent();
                        throw e_4;
                    case 3: return [2 /*return*/];
                }
            });
        });
    };
    /**
     * Converts api response for export into export object
     */
    ExportProvider.prototype.getExportObject = function (exp) {
        var myExport = new Export();
        myExport.id = exp.exportIdentifier;
        myExport.framework = exp.framework;
        myExport.type = exp.exportType;
        myExport.mask = exp.options.mask;
        myExport.includeImages = exp.options.includeImages;
        myExport.resizeImages = exp.options.resizeImages;
        myExport.imageWidth = exp.options.imageWidth;
        myExport.imageHeight = exp.options.imageHeight;
        myExport.trainingPercent = exp.options.trainingPercent;
        myExport.validationPercent = exp.options.validationPercent;
        myExport.testPercent = exp.options.testPercent;
        myExport.trainingImageCount = exp.options.trainingImageCount;
        myExport.validationImageCount = exp.options.validationImageCount;
        myExport.testImageCount = exp.options.testImageCount;
        myExport.totalImages = exp.totalImages;
        myExport.dateStarted = exp.dateStarted ? new Date(exp.dateStarted) : new Date();
        myExport.dateFinished = exp.dateFinished ? new Date(exp.dateFinished) : null;
        myExport.dateFailed = exp.dateFailed ? new Date(exp.dateFailed) : null;
        myExport.signedUrl = exp.signedUrl;
        myExport.classes = exp.classes.map(function (cls) {
            return {
                id: cls.classIdentifier,
                name: cls.name,
                color: cls.color
            };
        });
        if (exp.datasets) {
            myExport.datasets = exp.datasets;
        }
        if (exp.projects) {
            myExport.projects = exp.projects;
        }
        if (exp.type == ExportType.Detection) {
            myExport.normalizeBoundingBoxes = exp.options.normalizeBoundingBoxes;
        }
        return myExport;
    };
    ExportProvider = __decorate([
        Injectable(),
        __metadata("design:paramtypes", [API,
            JobProvider,
            Events,
            ToastController,
            TranslateService])
    ], ExportProvider);
    return ExportProvider;
}());
export { ExportProvider };
//# sourceMappingURL=export.js.map


// WEBPACK FOOTER //
// ./src/providers/export.ts.pre-build-optimizer.js